import { pubsub, cart } from '@services';
import { notyf } from '@modules';
import { d as debounce } from './debounce-Dg7s1ivP.js';

class CartItem extends HTMLElement {
  #unsubscriber;
  #lineItemIndex = this.dataset.lineItemIndex;
  #removeButton = this.querySelector('[data-line-item-remove]');
  #loadingOverlay = this.querySelector('.loading-overlay');

  connectedCallback() {
    this.#removeButton.addEventListener('click', (event) => this.#handleRemove(event));
    this.#unsubscriber = pubsub.subscribe('quantity:change', ({ line, quantity }) =>
      this.#handleQuantityChange(line, quantity)
    );
  }

  disconnectedCallback() {
    this.#unsubscriber();
  }

  /**
   * @description Handle the remove button click event
   * @param {Event} event - The event object
   */
  async #handleRemove(event) {
    event.preventDefault();

    this.#handleLoading(true);

    try {
      await cart.change({
        line: this.#lineItemIndex,
        quantity: 0,
      });
    } catch (error) {
      notyf.error(error.message);
    } finally {
      this.#handleLoading(false);
    }
  }

  /**
   * @description Handle the quantity change event
   * @param {number} line - The line item index
   * @param {number} quantity - The quantity
   */
  #handleQuantityChange = debounce(async (line, quantity) => {
    if (line !== this.#lineItemIndex) return;

    this.#handleLoading(true);

    try {
      await cart.change({
        line: this.#lineItemIndex,
        quantity,
      });
    } catch (error) {
      notyf.error(error.message);
    } finally {
      this.#handleLoading(false);
    }
  }, 300);

  /**
   * @description Handle the loading overlay
   * @param {boolean} loading - The loading state
   */
  #handleLoading(loading) {
    this.#loadingOverlay.ariaHidden = !loading;
  }
}

customElements.define('line-item', CartItem);
